<div class="header-area" [ngClass]="{'transparent': theme === 'transparent'}" [ngStyle]="{'direction':lang==='ar' ? 'rtl' : 'ltr' }">
  <div class="align-self-center">
    <a routerLink="/">
      <img class="logo" src="assets_main/images/logo.png" alt="" />
    </a>
  </div>
  <div class="links-container">
    <ul class="links open" *ngIf="toggle_menu && bar">
      <li>
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">{{'Home'|translate}}</a>
        <div class="line"></div>
      </li>
      <li>
        <a routerLink="/students" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">{{'Students'|translate}}</a>
        <div class="line"></div>
      </li>
      <li>
        <a routerLink="/coding-in-schools" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">{{'Schools'|translate}}</a>
        <div class="line"></div>
      </li>
      <li>
        <div class="dropdown">
          <button type="button" class="dropdown-toggle" (click)="isCommunityDropdownOpen = !isCommunityDropdownOpen" #dropdownBtnRef>
            {{'Community'|translate}}
          </button>
          <div class="dropdown-content" [ngClass]="{'open': isCommunityDropdownOpen}" #dropdownMenuRef>
            <a class="text-center dropdown-link" routerLink="/blog" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              {{'Blog'|translate}}
            </a>
            <a class="text-center dropdown-link" routerLink="/news" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              {{'News'|translate}}
            </a>
            <a class="text-center dropdown-link" routerLink="/contact" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              {{'Contact'|translate}}
            </a>
          </div>
        </div>
        <div class="line"></div>
      </li>
      <li *ngIf="!user">
        <a (click)="openLogin(login, closeToggle(), closePopup())" routerLinkActive="active" class="login"
          [routerLinkActiveOptions]="{ exact: true }">{{'Login'|translate}}</a>
        <div class="line"></div>
      </li>
      <li *ngIf="!user">
        <a (click)="openJoin(join, closeToggle(), closePopup())" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"><span class="join">{{'Join'|translate}}</span></a>
        <div class="line"></div>
      </li>
      <li *ngIf="user">
        <a (click)="logout()" routerLinkActive="active" class="login"
          [routerLinkActiveOptions]="{ exact: true }">{{'logout'|translate}}</a>
        <div class="line"></div>
      </li>
      <li *ngIf="user">
        <a [href]="dashboardRoute" routerLinkActive="active" class="login"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="join">
            {{(['school_admin', 'teacher', 'student'].includes(user.role) ? 'dashboard' : 'playground') | translate}}
          </span>
        </a>
        <div class="line"></div>
      </li>
      <li>
        <mat-form-field appearance="fill">
          <mat-label>
            <svg class="globe-img"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.6-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"/></svg>
            </mat-label>
          <mat-select [(ngModel)]="selectedValue" (selectionChange)="changeLang();" name="lang">
            <mat-option *ngFor="let lang of langs" [value]="lang.value">
              {{lang.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>
    </ul>
    <button class="toggle-menu" (click)="togg()">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</div>

<ng-template #loginAs let-modal>
  <div class="modal-body login-as-modal">
    <h2 class="title">Please select a teacher access to view your dashboard</h2>
    <div class="btns-wrapper">
      <button type="button" class="btn btn-success btn-role" *ngFor="let roleType of user?.roles" (click)="onSelectRole(roleType.name)">
        {{ roleType.name === 'school_admin' ? 'Admin Teacher' : roleType.name === 'teacher' ? 'Normal Teacher' : roleType.name }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #login let-modal>
  <div class="modal-body">
    <button type="button" class="close edit-close" aria-label="Close" (click)="modal.dismiss('')">
      <span class="edit-quit" aria-hidden="true">×</span>
    </button>
    <form #loginForm="ngForm" (ngSubmit)="Login()">
      <div>
        <input [(ngModel)]="usermodel.username" maxlength="256" name="username" #username="ngModel" required username
          type="text" class="edit-input mt-4" placeholder="Username Or User ID" autocomplete="new-username" />
      </div>
      <div>
        <input [(ngModel)]="usermodel.password" maxlength="256" name="password" #password="ngModel" required password
          class="edit-input mt-4 mb-4" type="password" placeholder="Password" autocomplete="new-password" />
      </div>
      <div class="d-flex justify-content-between edit-res">
        <div>
          <input type="submit" value="Login" class="edit-button mb-3" [ngClass]="{ disabled: !loginForm.form.valid || loading }"
            [disabled]="!loginForm.form.valid || loading" />
        </div>
        <div class="d-grid login-links mb-2">
          <a (click)="
              openForgetPassword(ForgetPassword, closeToggle(), closePopup())
            " class="edit-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            {{'forget-pass'|translate}}
          </a>
          <a (click)="openActiveCode(Code, closeToggle(), closePopup())" class="edit-link" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">{{'Resend-Activation-Code'|translate}}</a>
        </div>
      </div>
    </form>

    <div class="line-login"></div>
    <div>
      <p class="text-center mb-4 mt-3 edit-text">
        {{'dont-have-account'|translate}}
        <span (click)="openJoin(join, closeToggle(), closePopup())" class="color">{{'Sign-Up'|translate}}</span>
      </p>
    </div>
  </div>
</ng-template>

<ng-template #join let-modal>
  <div class="modal-register">
    <button type="button" class="close edit-exit" aria-label="Close" (click)="modal.dismiss('')">
      <span class="edit-quit" aria-hidden="true">×</span>
    </button>
    <div class="">
      <h3 class="text-center register mt-4">
        {{'SCHOOL-REGISTRATION'|translate}}
        <div class="line-reg"></div>
      </h3>
      <form [formGroup]="registerForm" (ngSubmit)="register()" class="mt-2">
        <div class="form-group">
          <div class="res">
            <input class="input form-control" name="username" type="text" placeholder="Username"
              formControlName="username" autocomplete="new-username" />
          </div>
          <div *ngIf="username?.invalid && (username?.dirty || username?.touched)">
            <small class="edit-msg res-msg" *ngIf="username?.errors?.required"><span
                class="edit-span">{{'Username-is-required'|translate}}</span></small>
            <small class="edit-msg res-msg" *ngIf="username?.errors?.minlength"><span
                class="edit-span">{{'username-verify'|translate}}</span></small>
            <small class="edit-msg res-msg" *ngIf="!username?.errors?.minlength && username?.errors?.pattern"><span
                class="edit-span">{{'username-valid'|translate}}</span></small>
          </div>
        </div>
        <div>
          <div class="res">
            <input class="input form-control" name="school_name" formControlName="school_name" type="text"
              placeholder="School Name" autocomplete="new-schoolname" />
          </div>
          <div *ngIf="
              schoolname?.invalid && (schoolname?.dirty || schoolname?.touched)
            ">
            <small class="edit-msg res-msg" *ngIf="schoolname?.errors?.required"><span
                class="edit-span">{{'Schoolname-is-required'|translate}}</span></small>
          </div>
        </div>
        <div>
          <div class="res">
            <input class="input form-control" name="email" formControlName="email" type="email" placeholder="Email"
              autocomplete="new-email" />
          </div>
          <div *ngIf="email?.invalid && (email?.dirty || email?.touched)">
            <small class="edit-msg res-msg" *ngIf="email?.errors?.required"><span
                class="edit-span">{{'Email-is-required'|translate}}</span></small>
            <small class="edit-msg res-msg" *ngIf="email?.errors?.email"><span class="edit-span">
                {{'email-verify'|translate}} </span></small>
          </div>
        </div>
        <div class="d-flex edit-pass">
          <div>
            <div class="res">
              <input class="input-edit form-control" type="password" name="password" formControlName="password"
                placeholder="Password" autocomplete="new-password" />
            </div>
            <div *ngIf="
                password?.invalid && (password?.dirty || password?.touched)
              ">
              <small class="edit-msg res-msg" *ngIf="password?.errors?.required"><span
                  class="text-center span-edit edit-query">{{'Password-is-required'|translate}}</span></small>
              <small class="edit-msg res-msg" *ngIf="password?.errors?.minlength"><span
                  class="text-center span-edit edit-query">{{'pass-verify'|translate}}</span></small>
            </div>
          </div>
          <div>
            <div class="res">
              <input class="input-edit form-control" type="password" name="retypePassword"
                formControlName="retypePassword" placeholder="Retype Password" autocomplete="new-password" />
            </div>
            <div *ngIf="
                retypePassword?.invalid &&
                (retypePassword?.dirty || retypePassword?.touched)
              ">
              <small class="edit-msg res-msg" *ngIf="retypePassword?.errors?.required"><span
                  class="span-edit edit-query">{{'RetypePassword-is-required'|translate}}</span></small>
              <small class="edit-msg res-msg mt-1" *ngIf="retypePassword?.hasError('matching')"><span
                  class="span-edit edit-query">{{'Password-didnt-match'|translate}}</span></small>
            </div>
          </div>
        </div>
        <div class="line-input mt-3"></div>

        <div class="res">
          <input value="JOIN FOR FREE" type="submit" [disabled]="registerForm.invalid || loading"
            [ngClass]="{ disabled: !registerForm.valid || loading }" class="edit-btn mt-2 mb-2" />
        </div>
        <div class="mt-3 mb-5 res">
          <a (click)="openLogin(login, closeToggle(), closePopup())"
            class="link-edit">{{'Already-have-account'|translate}}</a>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #ForgetPassword let-modal>
  <div class="modal-links">
    <button type="button" class="close exit" aria-label="Close" (click)="modal.dismiss('')">
      <span class="quit" aria-hidden="true">×</span>
    </button>
    <div class="background">
      <h3 class="edit-Password">{{'New-Password'|translate}}</h3>
    </div>
    <h5 class="text-center text-password mt-5">
      {{'enter-email'|translate}}
    </h5>
    <form [formGroup]="forgetForm" (ngSubmit)="forgetPassword()">
      <div class="input-Password">
        <div>
          <input class="pass-input" type="text" placeholder="Email Or Username" name="username_or_email"
            formControlName="username_or_email" />
        </div>
        <div *ngIf="userEmail?.invalid && (userEmail?.dirty || userEmail?.touched)">
          <small class="edit-msg" *ngIf="userEmail?.errors?.required"><span class="res-msg">
              {{'email-verify'|translate}} </span></small>
        </div>
        <div class="res">
          <input [disabled]="forgetForm.invalid || loading" [ngClass]="{ disabled: !forgetForm.valid || loading }" class="mt-2 pass-submit"
            value="Submit" type="submit" />
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #Code let-modal>
  <div class="modal-links">
    <button type="button" class="close exit" aria-label="Close" (click)="modal.dismiss('')">
      <span class="quit" aria-hidden="true">×</span>
    </button>
    <div class="background">
      <h3 class="edit-Password">{{'Resend-Activation-Code'|translate}}</h3>
    </div>
    <h5 class="text-center text-password mt-5">
      {{'email-request'|translate}}
    </h5>
    <form [formGroup]="activeForm" (ngSubmit)="resendCode()">
      <div class="input-Password">
        <div>
          <input class="password-input" type="email" placeholder="Enter Email" name="email" formControlName="email" />
        </div>
        <div *ngIf="Email?.invalid && (Email?.dirty || Email?.touched)">
          <small class="edit-msg" *ngIf="Email?.errors?.required"><span
              class="res-msg">{{'email-verify'|translate}}</span></small>
          <small class="edit-msg" *ngIf="Email?.errors?.email"><span
              class="res-msg">{{'email-verify'|translate}}</span></small>
        </div>
        <div class="res">
          <input [disabled]="activeForm.invalid || loading" [ngClass]="{ disabled: !activeForm.valid || loading }" class="mt-2 pass-submit"
            value="Send" type="submit" />
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template
	#resetpassword
	let-modal
>
	<div class="modal-links">
		<button
			type="button"
			class="close exit"
			aria-label="Close"
			(click)="modal.dismiss('')"
		>
			<span
				class="quit"
				aria-hidden="true"
				>×</span
			>
		</button>
		<div class="background">
			<h3 class="edit-Password">{{'Resend-Activation-Code'|translate}}</h3>
		</div>

		<form
			[formGroup]="resetPasswordForm"
			(ngSubmit)="resetPass()"
			class="mt-4"
		>
			<div class="input-field  mb-2">
				<label class="input-label"
					>New Password
					<span class="red">*</span>
				</label>
				<div class="input-container">
					<div class="res">
						<input
							class="input-edit form-control"
							type="password"
							name="password"
							formControlName="password"
							placeholder="Password"
							autocomplete="new-password"
						/>
					</div>
					<div
						*ngIf="
          resetPassword?.invalid && (resetPassword?.dirty || resetPassword?.touched)
            "
					>
						<small
							class="edit-msg res-msg"
							*ngIf="resetPassword?.errors?.required"
							><span class="text-center span-edit edit-query"
								>{{'Password-is-required'|translate}}</span
							></small
						>
						<small
							class="edit-msg res-msg"
							*ngIf="resetPassword?.errors?.minlength"
							><span class="text-center span-edit edit-query"
								>{{'pass-verify'|translate}}</span
							></small
						>
					</div>
				</div>
			</div>

			<div class="input-field">
				<label class="input-label"
					>Retype Password
					<span class="red">*</span>
				</label>
				<div>
					<div class="res">
						<input
							class="input-edit form-control"
							type="password"
							name="retypePassword"
							formControlName="retypePassword"
							placeholder="Retype Password"
							autocomplete="new-password"
						/>
					</div>
					<div
						*ngIf="
          resetRetypePassword?.invalid &&
              (resetRetypePassword?.dirty || resetRetypePassword?.touched)
            "
					>
						<small
							class="edit-msg res-msg"
							*ngIf="resetRetypePassword?.errors?.required"
							><span class="span-edit edit-query"
								>{{'RetypePassword-is-required'|translate}}</span
							></small
						>
						<small
							class="edit-msg res-msg mt-1"
							*ngIf="resetRetypePassword?.hasError('matching')"
							><span class="span-edit edit-query"
								>{{'Password-didnt-match'|translate}}</span
							></small
						>
					</div>
				</div>
			</div>
			<div class="res">
				<input
					value="Submit"
					type="submit"
					[disabled]="resetPasswordForm.invalid || loading"
					[ngClass]="{ disabled: !resetPasswordForm.valid || loading }"
					class="edit-btn mt-2 mb-2"
				/>
			</div>
		</form>
	</div>
</ng-template>

